import {
    Component, ChangeDetectorRef, OnDestroy, OnInit,
    Output, EventEmitter
} from '@angular/core';
import { IdentificationStepsService } from '../../services/identification-steps.service';
import { UserWasChangedListenerInterface } from '../../../shared/contracts/user-was-changed-listener.interface';
import { AuthenticatedUserRepositoryService } from '../../services/authenticated-user-repository.service';
import { DeliveryStepsService } from '../../services/delivery-steps.service';

@Component({
    selector: 'payment-identification-existent-email',
    templateUrl: './payment.identification.existent-email.component.html',
    styleUrls: ['../../payment.component.scss']

})
export class PaymentIdentificationExistentEmailComponent {
    public password: string;
    public loading = false;
    public authorized = true;
    public attempts = 0;
    @Output() requestingPasswordRecovery: EventEmitter<any> = new EventEmitter();

    constructor(
        protected identificationStepsService: IdentificationStepsService
    ) { }

    /**
     * This call login at services.
     **/
    public login() {
        if (this.password == undefined) {
            const passwordInput = document.getElementById('payment-identification-existent-email-password') as HTMLInputElement;
            if (passwordInput && passwordInput.value.trim() !== '') {
                this.password = passwordInput.value.trim();
                console.log('new pass');
            }
        }
        if (this.password.length >= 6) {
            this.loading = true;
            this.identificationStepsService.login(this.password).subscribe(() => {
                this.loading = false;
                this.attempts += 1;
            }, () => {
                this.loading = false;
                this.authorized = false;
                this.attempts += 1;
            });
        }
    }
    /**
     * This reset inputted email at services.
     **/
    public resetEmail(): void {
        this.identificationStepsService.resetEmail();
        this.identificationStepsService.resetUser();
    }
    /**
     * 'authorized' property setter.
     **/
    public setAuthorized(value: boolean): void {
        this.authorized = value;
    }
    /**
     * This emit requestingPasswordRecovery event.
     **/
    public requestPasswordRecovery() {
        this.requestingPasswordRecovery.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/identification/existent-email/payment.identification.existent-email.component.ts